import SuggestionStatus from './SuggestionStatus';

export default SuggestionStatus;
